"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_helmet_1 = require("react-helmet");
const HelmetDatoCms = ({ seo, favicon, children, ...rest }) => {
    return react_1.default.createElement(react_helmet_1.Helmet, rest, (seo ? seo.tags : [])
        .concat(favicon ? favicon.tags : [])
        .map((item, i) => react_1.default.createElement(item.tagName, Object.assign({ key: `helmet-datocms-${i}` }, Object.entries(item.attributes || {}).reduce((acc, [name, value]) => {
        if (value) {
            acc[name] = value;
        }
        return acc;
    }, {})), item.content))
        .concat(children));
};
HelmetDatoCms.renderStatic = react_helmet_1.Helmet.renderStatic;
exports.default = HelmetDatoCms;
//# sourceMappingURL=helmet.js.map